/* La Peau — alternativas a agotados (sections/lp-alternativas-pdp.liquid): agregar al carrito. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(msg) {
    var el = document.querySelector('.lp-gt-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'lp-gt-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-show');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-show'); }, 2600);
  }

  /* Mismo patrón que la ficha (sections/lp-main-product.liquid): cart/add.js con sections del cajón y
     cart:change con open_cart_drawer, así el cajón se abre y el obsequio se reconcilia. */
  async function add(btn) {
    var drawerEl = document.querySelector('hdt-cart-drawer');
    var sid = drawerEl ? drawerEl.getAttribute('section-id') : null;
    var body = { items: [{ id: Number(btn.dataset.lpAltAdd), quantity: 1 }] };
    if (sid) body.sections = sid;
    btn.disabled = true;
    try {
      var res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('add');
      var data = await res.json();
      var cart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
      if (data.sections) cart.sections = data.sections;
      btn.classList.add('is-added');
      btn.textContent = 'Agregado';
      if (window.LpModal && window.LpModal.isOpen()) window.LpModal.close();
      toast('Agregaste ' + (btn.dataset.lpAltVendor || 'la alternativa') + ' en lugar del agotado');
      if (sid) {
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', actionAfterATC: 'open_cart_drawer', cart: cart } }));
      } else {
        location.href = root + 'cart';
      }
      setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = 'Agregar'; btn.disabled = false; }, 1400);
    } catch (e) {
      btn.disabled = false;
    }
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-lp-alt-add]');
    if (addBtn) { e.preventDefault(); add(addBtn); }
  });
})();
